
export const routes = [
    {
        name: 'Home',
        slug: '/',
        position: [50, 6, 0]
    },
    {
        name: 'About',
        slug: '/about',
        position: [30, 10, 30]
    },
    {
        name: 'Projects',
        slug: '/projects',
        position: [10, 20, 50]
    },
    {
        name: 'Contact',
        slug: '/contact',
        position: [20, 15, 40]
    }
]